// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"style_hamburger__24osa","open":"style_open__2qNu-"};